import { EntityBase } from './EntityBase';
import { MaterialAssessmentCategory } from './MaterialAssessmentCategory';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class AssessmentCategory extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   assessmentCategoryId: number;
   name: string;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   materialAssessmentCategories: MaterialAssessmentCategory[];
}

